// file: src/pages/PremiumClubLeadsAdmin.jsx
//
// Unlisted admin view (not in the sidebar) so the business can see everyone
// who clicked "Interested" on the Premium Club dashboard teaser. Same
// admin-by-obscurity convention as the rest of this backend: real protection
// is the obfuscated route path, not a role check.
import { useEffect, useState } from "react";
import { Crown, RefreshCw, Users } from "lucide-react";
import apiClient from "../common/apiClient";

export default function PremiumClubLeadsAdmin() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try {
      const res = await apiClient(
        "get",
        "/ijscui/probroker-admin/ceknvuhbd/PremiumClub/protected/list"
      );
      if (res.success) setRows(res.data?.data?.rows || []);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, []);

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between flex-wrap gap-3">
        <div className="flex items-center gap-2">
          <Crown size={22} className="text-[#c99b2c]" />
          <h1 className="text-2xl font-bold">Premium Club — Interested Users</h1>
        </div>
        <button
          onClick={load}
          className="flex items-center gap-1.5 text-sm font-medium px-3 py-1.5 rounded-lg border border-border hover:bg-muted"
        >
          <RefreshCw size={14} className={loading ? "animate-spin" : ""} />
          Refresh
        </button>
      </div>

      <div className="glass-card rounded-xl p-4 flex items-center gap-3">
        <Users size={18} className="text-primary" />
        <span className="text-sm">
          <strong>{rows.length}</strong> user{rows.length === 1 ? "" : "s"} clicked Interested
        </span>
      </div>

      <div className="glass-card rounded-xl overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="text-left text-xs uppercase tracking-wide text-muted-foreground border-b border-border">
              <th className="px-4 py-3">Name</th>
              <th className="px-4 py-3">Number</th>
              <th className="px-4 py-3">Email</th>
              <th className="px-4 py-3">City</th>
              <th className="px-4 py-3">Clicked At</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r._id} className="border-b border-border last:border-0">
                <td className="px-4 py-3 font-medium">{r.name || "—"}</td>
                <td className="px-4 py-3">{r.number || "—"}</td>
                <td className="px-4 py-3">{r.email || "—"}</td>
                <td className="px-4 py-3">{r.city || "—"}</td>
                <td className="px-4 py-3 text-muted-foreground">
                  {r.createdAt ? new Date(r.createdAt).toLocaleString() : "—"}
                </td>
              </tr>
            ))}
            {!loading && rows.length === 0 && (
              <tr>
                <td colSpan={5} className="px-4 py-8 text-center text-muted-foreground">
                  No one has clicked "Interested" yet.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
